/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getConfigStatusDataSchema = z.object({
  env: z.record(z.string(), z.record(z.string(), z.string())),
  vars: z.record(z.string(), z.unknown()),
});

export type IGetConfigStatusData = z.infer<typeof getConfigStatusDataSchema>;

export const getConfigStatusResponseSchema = createApiResponseSchema(
  getConfigStatusDataSchema,
) as z.ZodSchema<IAPI<IGetConfigStatusData>>;

export type IGetConfigStatusResponse = IAPI<IGetConfigStatusData>;
